<template>
  <div class="flex w-full">
    <import-listing
      ref="importListing"
      class="processing-leads-listing"
      :importSourceUrl="importSourceUrl"
      :importLeadType="importLeadType"
      :importTableColumns="importedUsersTableColumns"
      :importTableOptions="importedUsersTableOptions"
      :percentSwitch="percentSwitch"
      :showEmptyState="false"
      @downloadCsvOfLeads="downloadCsvOfLeads"
    >
    </import-listing>
  </div>
</template>

<script>
import axios from 'axios';
import { mapActions } from 'vuex';
import ImportListing from '@/components/import-listing.vue';
import demoModeValuesMixin from '@/mixin/demoModeValuesMixin.js';

let self;

export default {
  middleware: 'auth',
  metaInfo() {
    return {
      title: this.$t('frontend_groovemail_import_user_listing_processing_status'),
    };
  },

  mixins: [demoModeValuesMixin],

  props: {
    importSourceUrl: {
      required: true,
    },
    importLeadType: {
      required: false,
    },
    percentSwitch: {
      required: false,
    },
  },

  data() {
    return {
      importedUsersTableColumns: [
        'user_email',
        'csv_name',
        'created_at',
        'actions',
      ],
      importedUsersTableOptions: {
        perPage: 10,
        debounce: 1000,
        alwaysShowPerPageSelect: true,
        perPageValues: [10, 25, 50, 100],
        pagination: { chunk: 5 },
        sortIcon: {
          base: 'fa',
          is: 'fa-sort',
          up: 'fa-sort-asc',
          down: 'fa-sort-desc',
        },
        texts: {
          filterPlaceholder: this.$t('frontend_groovemail_tables_search_query'),
        },
        sortable: ['csv_name','user_email'],
        filterable: ['csv_name'],
        headings: {
          user_email: () => this.$t('frontend_groovemail_admin_import_user_approval_user_email_header'),
          csv_name: () => this.$t('frontend_groovemail_admin_import_user_approval_csv_name_header'),
          created_at: () => this.$t('frontend_groovemail_admin_import_user_approval_file_upload_date_header'),
        },
        requestFunction(data) {
          const requestParams = { ...data, ascending: 1 - data.ascending };
          requestParams.approved = 4;
          if (!(requestParams && requestParams.orderBy)) {
            requestParams.orderBy = 'created_at';
            requestParams.ascending = 0;
          }
          const self = this;
          return axios
            .get(self.url, {
              params: requestParams,
            })
            .catch((e) => {
              self.dispatch('error', e);
            });
        },
        responseAdapter({ data }) {
          if(self.demoMode) {
            const newData = data?.data.map((obj) => ({
              ...obj,
              user_email: self.basicEmailText,
            }));

            return {
              data: newData,
              count: newData.length,
            };
          }
          return {
            data: data.data,
            count: data.total,
          };
        },
      },
    };
  },

  components: {
    ImportListing
  },

  created() {
    self = this;
  },

  watch: {
    // Used to refresh import table data table when demo mode changes
    demoMode() {
      this.$refs.importListing.$refs.serverTable.$refs.importTable.refresh();
    },
  },

  computed: {
    // Used to return demoMode value from store.
    demoMode() {
      return this.$store.state.demoMode.isDemoMode;
    },
  },


  methods: {
    ...mapActions('loader', ['LOADING']),

    // show loader
    showLoader() {
      this.LOADING(true);
    },

    // hide loader
    hideLoader (){
      this.LOADING(false);
    },

	  /**
     * Emits event to trigger downloading of csv of different type of contacts (all, good, bad).
     * @param {object} csvData data related to csv file
     * @param {string} url url for downloading data
     * @param {number} type type of contact
     *    0 - bad contacts
     *    1 - good contacts
     *    2 - all contacts
     */
    downloadCsvOfLeads(csvData, url, type) {
      this.$emit('downloadCsvOfLeads', csvData, url, type);
    },
  },
};
</script>


<style lang="scss">
.processing-leads-listing .groovemail-common-import-leads-table #gd-server-table-view {
  table {
    th:nth-child(1),
    td:nth-child(1),
    th:nth-child(2),
    td:nth-child(2) {
      width: 30%;
      word-break: break-all;
    }
    th:nth-child(3),
    td:nth-child(3) {
      width: 20%;
    }
  }
}
</style>
